import { useNavigate } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import PackageCard from "../components/PackageCard";
import CarePlans from "../components/CarePlans";
import ProcessTimeline from "../components/ProcessTimeline";
import { PACKAGES } from "../data/content";

export default function Packages() {
  const navigate = useNavigate();
  return (
    <div data-testid="packages-page">
      <PageHeader
        eyebrow="Website Packages"
        title="Premium websites at honest prices"
        sub="Fixed-price packages built for Canadian small businesses. Everything is transparent — pick a tier, and we'll take it from there."
      />

      <section id="pricing" className="mx-auto max-w-7xl px-5 pb-8 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PACKAGES.map((pkg, i) => (
            <PackageCard
              key={pkg.id}
              pkg={pkg}
              index={i}
              onCta={() => navigate("/contact", { state: { service: pkg.name } })}
              ctaLabel={pkg.custom ? "Contact Us for a Custom Quote" : "Get Started"}
            />
          ))}
        </div>
        <p className="mt-8 text-center text-sm text-muted-foreground">
          All prices in CAD. Every package includes responsive design and a smooth, guided launch.
        </p>
      </section>

      <CarePlans />
      <ProcessTimeline />
    </div>
  );
}
